module.exports = __webpack_public_path__ + "static/media/weather.ef162168.jpg";